import { CALL_BB_API } from '../api/browsboxApi';
import {
  ROUTE_NSI_PRODUCT_TYPES,
  ROUTE_BASEMODULE_ITEMS_ORDER,
  ROUTE_BASEMODULE_ITEMS, ROUTE_BASEMODULE_ITEM,
  ROUTE_BASEMODULE_ITEM_PUBLISH, ROUTE_BASEMODULE_ITEM_UNPUBLISH,
  ROUTE_NSI_PRODUCT_TYPE, ROUTE_NSI_DETAIL_FILTERS, ROUTE_NSI_ITEM_DETAIL_FILTERS,
} from '../api/routes';
import { buildRoute } from '../api';

export const BASE_MODULE_ITEMS_ORDER_REQUEST = 'BASE_MODULE_ITEMS_ORDER_REQUEST';
export const BASE_MODULE_ITEMS_ORDER_SUCCESS = 'BASE_MODULE_ITEMS_ORDER_SUCCESS';
export const BASE_MODULE_ITEMS_ORDER_FAILURE = 'BASE_MODULE_ITEMS_ORDER_FAILURE';

const postBaseModuleItemsOrder = (value, id) => {
  const endpoint = buildRoute(ROUTE_BASEMODULE_ITEMS_ORDER, { id });
  return {
    [CALL_BB_API]: {
      types: [BASE_MODULE_ITEMS_ORDER_REQUEST, BASE_MODULE_ITEMS_ORDER_SUCCESS, BASE_MODULE_ITEMS_ORDER_FAILURE],
      endpoint,
      method: 'POST',
      json: value,
    },
  };
};

export const orderBaseModuleItems = value => (dispatch, getState) => {
  const { baseModule } = getState();
  return dispatch(postBaseModuleItemsOrder(value, baseModule.currentModule.id));
};

export const BASE_MODULE_ITEM_SAVE_REQUEST = 'BASE_MODULE_ITEM_SAVE_REQUEST';
export const BASE_MODULE_ITEM_SAVE_SUCCESS = 'BASE_MODULE_ITEM_SAVE_SUCCESS';
export const BASE_MODULE_ITEM_SAVE_FAILURE = 'BASE_MODULE_ITEM_SAVE_FAILURE';

const postBaseModuleItem = (value, entityId) => {
  const endpoint = buildRoute(ROUTE_BASEMODULE_ITEMS, { entityId });
  return {
    [CALL_BB_API]: {
      types: [BASE_MODULE_ITEM_SAVE_REQUEST, BASE_MODULE_ITEM_SAVE_SUCCESS, BASE_MODULE_ITEM_SAVE_FAILURE],
      endpoint,
      method: 'POST',
      json: value,
    },
  };
};

export const saveBaseModuleItem = value => (dispatch, getState) => {
  const { baseModule } = getState();
  return dispatch(postBaseModuleItem(value, baseModule.currentModule.id));
};


export const BASE_MODULE_ITEM_UPDATE_REQUEST = 'BASE_MODULE_ITEM_UPDATE_REQUEST';
export const BASE_MODULE_ITEM_UPDATE_SUCCESS = 'BASE_MODULE_ITEM_UPDATE_SUCCESS';
export const BASE_MODULE_ITEM_UPDATE_FAILURE = 'BASE_MODULE_ITEM_UPDATE_FAILURE';

const putBaseModuleItem = (value, itemId) => {
  const endpoint = buildRoute(ROUTE_BASEMODULE_ITEM, { itemId });
  return {
    [CALL_BB_API]: {
      types: [BASE_MODULE_ITEM_UPDATE_REQUEST, BASE_MODULE_ITEM_UPDATE_SUCCESS, BASE_MODULE_ITEM_UPDATE_FAILURE],
      endpoint,
      method: 'PUT',
      json: value,
    },
  };
};

export const updateBaseModuleItem = value => (dispatch, getState) => {
  const { baseModuleItems } = getState();
  return dispatch(putBaseModuleItem(value, baseModuleItems.currentItem.id));
};

export const BASE_MODULE_ITEM_NSI_TYPES_REQUEST = 'BASE_MODULE_ITEM_NSI_TYPES_REQUEST';
export const BASE_MODULE_ITEM_NSI_TYPES_SUCCESS = 'BASE_MODULE_ITEM_NSI_TYPES_SUCCESS';
export const BASE_MODULE_ITEM_NSI_TYPES_FAILURE = 'BASE_MODULE_ITEM_NSI_TYPES_FAILURE';

const nsiProductTypes = () => {
  const endpoint = ROUTE_NSI_PRODUCT_TYPES;
  return {
    [CALL_BB_API]: {
      types: [
        BASE_MODULE_ITEM_NSI_TYPES_REQUEST,
        BASE_MODULE_ITEM_NSI_TYPES_SUCCESS,
        BASE_MODULE_ITEM_NSI_TYPES_FAILURE,
      ],
      endpoint,
      method: 'GET',
    },
  };
};

export const getNsiProductTypes = () => dispatch => dispatch(nsiProductTypes());

export const NSI_DETAIL_FILTERS_REQUEST = 'NSI_DETAIL_FILTERS_REQUEST';
export const NSI_DETAIL_FILTERS_SUCCESS = 'NSI_DETAIL_FILTERS_SUCCESS';
export const NSI_DETAIL_FILTERS_FAILURE = 'NSI_DETAIL_FILTERS_FAILURE';

const fetchNsiDetailFilters = () => {
  const endpoint = ROUTE_NSI_DETAIL_FILTERS;
  return {
    [CALL_BB_API]: {
      types: [NSI_DETAIL_FILTERS_REQUEST, NSI_DETAIL_FILTERS_SUCCESS, NSI_DETAIL_FILTERS_FAILURE],
      endpoint,
      method: 'GET',
    },
  };
};

export const getNsiDetailFilters = () => dispatch => dispatch(
  fetchNsiDetailFilters(),
);

export const NSI_SAVE_DETAIL_FILTERS_REQUEST = 'NSI_SAVE_DETAIL_FILTERS_REQUEST';
export const NSI_SAVE_DETAIL_FILTERS_SUCCESS = 'NSI_SAVE_DETAIL_FILTERS_SUCCESS';
export const NSI_SAVE_DETAIL_FILTERS_FAILURE = 'NSI_SAVE_DETAIL_FILTERS_FAILURE';

const postNsiDetailFilters = (value) => {
  const endpoint = ROUTE_NSI_DETAIL_FILTERS;
  return {
    [CALL_BB_API]: {
      types: [NSI_SAVE_DETAIL_FILTERS_REQUEST, NSI_SAVE_DETAIL_FILTERS_SUCCESS, NSI_SAVE_DETAIL_FILTERS_FAILURE],
      endpoint,
      method: 'POST',
      json: value,
    },
  };
};

export const saveNsiDetailFilters = value => dispatch => dispatch(
  postNsiDetailFilters(value),
);

export const NSI_GET_ITEM_DETAIL_FILTERS_REQUEST = 'NSI_GET_ITEM_DETAIL_FILTERS_REQUEST';
export const NSI_GET_ITEM_DETAIL_FILTERS_SUCCESS = 'NSI_GET_ITEM_DETAIL_FILTERS_SUCCESS';
export const NSI_GET_ITEM_DETAIL_FILTERS_FAILURE = 'NSI_GET_ITEM_DETAIL_FILTERS_FAILURE';

const fetchNsiItemDetailFilters = (id) => {
  const endpoint = buildRoute(ROUTE_NSI_ITEM_DETAIL_FILTERS, { id });
  return {
    [CALL_BB_API]: {
      types: [
        NSI_GET_ITEM_DETAIL_FILTERS_REQUEST,
        NSI_GET_ITEM_DETAIL_FILTERS_SUCCESS,
        NSI_GET_ITEM_DETAIL_FILTERS_FAILURE,
      ],
      endpoint,
      method: 'GET',
    },
  };
};

export const getNsiItemDetailFilters = id => dispatch => dispatch(
  fetchNsiItemDetailFilters(id),
);

export const NSI_TYPE_SAVE_REQUEST = 'NSI_TYPE_SAVE_REQUEST';
export const NSI_TYPE_SAVE_SUCCESS = 'NSI_TYPE_SAVE_SUCCESS';
export const NSI_TYPE_SAVE_FAILURE = 'NSI_TYPE_SAVE_FAILURE';

const postNsiProductType = (id, value) => {
  const endpoint = buildRoute(ROUTE_NSI_PRODUCT_TYPE, { id });
  return {
    [CALL_BB_API]: {
      types: [NSI_TYPE_SAVE_REQUEST, NSI_TYPE_SAVE_SUCCESS, NSI_TYPE_SAVE_FAILURE],
      endpoint,
      method: 'POST',
      json: value,
    },
  };
};

export const saveNsiProductType = (id, value) => dispatch => dispatch(
  postNsiProductType(id, value),
);

export const NSI_TYPE_GET_REQUEST = 'NSI_TYPE_GET_REQUEST';
export const NSI_TYPE_GET_SUCCESS = 'NSI_TYPE_GET_SUCCESS';
export const NSI_TYPE_GET_FAILURE = 'NSI_TYPE_GET_FAILURE';

const getNsiProductType = (id) => {
  const endpoint = buildRoute(ROUTE_NSI_PRODUCT_TYPE, { id });
  return {
    [CALL_BB_API]: {
      types: [NSI_TYPE_GET_REQUEST, NSI_TYPE_GET_SUCCESS, NSI_TYPE_GET_FAILURE],
      endpoint,
      method: 'GET',
    },
  };
};

export const receiveNsiProductType = id => dispatch => dispatch(
  getNsiProductType(id),
);


export const BASE_MODULE_ITEM_DELETE_REQUEST = 'BASE_MODULE_ITEM_DELETE_REQUEST';
export const BASE_MODULE_ITEM_DELETE_SUCCESS = 'BASE_MODULE_ITEM_DELETE_SUCCESS';
export const BASE_MODULE_ITEM_DELETE_FAILURE = 'BASE_MODULE_ITEM_DELETE_FAILURE';

const deleteBaseModuleItem = (itemId) => {
  const endpoint = buildRoute(ROUTE_BASEMODULE_ITEM, { itemId });
  return {
    [CALL_BB_API]: {
      types: [BASE_MODULE_ITEM_DELETE_REQUEST, BASE_MODULE_ITEM_DELETE_SUCCESS, BASE_MODULE_ITEM_DELETE_FAILURE],
      endpoint,
      method: 'DELETE',
    },
  };
};

export const removeBaseModuleItem = () => (dispatch, getState) => {
  const { baseModuleItems } = getState();
  return dispatch(deleteBaseModuleItem(baseModuleItems.currentItem.id));
};


export const BASE_MODULE_ITEMS_LIST_REQUEST = 'BASE_MODULE_ITEMS_LIST_REQUEST';
export const BASE_MODULE_ITEMS_LIST_SUCCESS = 'BASE_MODULE_ITEMS_LIST_SUCCESS';
export const BASE_MODULE_ITEMS_LIST_FAILURE = 'BASE_MODULE_ITEMS_LIST_FAILURE';

const fetchBaseModuleItemsList = (entityId) => {
  const endpoint = buildRoute(ROUTE_BASEMODULE_ITEMS, { entityId });
  return {
    [CALL_BB_API]: {
      types: [BASE_MODULE_ITEMS_LIST_REQUEST, BASE_MODULE_ITEMS_LIST_SUCCESS, BASE_MODULE_ITEMS_LIST_FAILURE],
      endpoint,
      method: 'GET',
    },
  };
};

export const getBaseModuleItemsList = () => (dispatch, getState) => {
  const { baseModule } = getState();
  return dispatch(fetchBaseModuleItemsList(baseModule.currentModule.id));
};

export const BASE_MODULE_ITEM_PUBLISH_REQUEST = 'BASE_MODULE_ITEM_PUBLISH_REQUEST';
export const BASE_MODULE_ITEM_PUBLISH_SUCCESS = 'BASE_MODULE_ITEM_PUBLISH_SUCCESS';
export const BASE_MODULE_ITEM_PUBLISH_FAILURE = 'BASE_MODULE_ITEM_PUBLISH_FAILURE';

const patchPublishBaseModuleItem = (routeId) => {
  const endpoint = buildRoute(ROUTE_BASEMODULE_ITEM_PUBLISH, { routeId });
  return {
    [CALL_BB_API]: {
      types: [
        BASE_MODULE_ITEM_PUBLISH_REQUEST,
        BASE_MODULE_ITEM_PUBLISH_SUCCESS,
        BASE_MODULE_ITEM_PUBLISH_FAILURE,
      ],
      endpoint,
      method: 'PATCH',
    },
  };
};

export const BASE_MODULE_ITEM_UNPUBLISH_REQUEST = 'BASE_MODULE_ITEM_UNPUBLISH_REQUEST';
export const BASE_MODULE_ITEM_UNPUBLISH_SUCCESS = 'BASE_MODULE_ITEM_UNPUBLISH_SUCCESS';
export const BASE_MODULE_ITEM_UNPUBLISH_FAILURE = 'BASE_MODULE_ITEM_UNPUBLISH_FAILURE';

const patchUnpublishBaseModuleItem = (routeId) => {
  const endpoint = buildRoute(ROUTE_BASEMODULE_ITEM_UNPUBLISH, { routeId });
  return {
    [CALL_BB_API]: {
      types: [
        BASE_MODULE_ITEM_UNPUBLISH_REQUEST,
        BASE_MODULE_ITEM_UNPUBLISH_SUCCESS,
        BASE_MODULE_ITEM_UNPUBLISH_FAILURE,
      ],
      endpoint,
      method: 'PATCH',
    },
  };
};

export const togglePublishBaseModuleItem = (routeId, value) => (dispatch) => {
  const action = value ? patchPublishBaseModuleItem(routeId) : patchUnpublishBaseModuleItem(routeId);

  return dispatch(action);
};

export const SET_CURRENT_MODULE_ITEM = 'SET_CURRENT_MODULE_ITEM';
export const setCurrentModuleItem = function setCurrentModuleItem(item) {
  return { type: SET_CURRENT_MODULE_ITEM, payload: item };
};

export const SET_MODULE_ITEMS_FILTER_BY_NAME = 'SET_MODULE_ITEMS_FILTER_BY_NAME';
export const setModuleItemsFilterByName = function setModuleItemsFilterByName(filterValue) {
  return { type: SET_MODULE_ITEMS_FILTER_BY_NAME, payload: filterValue };
};

export const SET_MODULE_ITEMS_FILTER_BY_CATEGORY = 'SET_MODULE_ITEMS_FILTER_BY_CATEGORY';
export const setModuleItemsFilterByCategory = function setModuleItemsFilterByCategory(filterValue) {
  return { type: SET_MODULE_ITEMS_FILTER_BY_CATEGORY, payload: filterValue };
};

export const CLEAR_FORM_MEDIA_FILED = 'CLEAR_FORM_MEDIA_FILED';
export const clearFormMediaField = () => ({ type: CLEAR_FORM_MEDIA_FILED });



// WEBPACK FOOTER //
// ./src/actions/baseModuleItems.js